<div class="dashboard-table-details-artworks box_default box_white" >
  <header>
    <h3>Latest Artworks</h3>
  </header>
  <div class="loader">
    <div class="dimmed" [hidden]="status != LOADING">
      <div class="dimmed_box"></div>
      <div class="dimmed_box"></div>
      <div class="dimmed_box"></div>
    </div>
    <!-- <core-helpers-box-loading [hidden]="status != LOADING"></core-helpers-box-loading> -->
  </div>
    
    <div class="project-uploaded-versions" *ngIf="status == DONE">
      <project-details-versions-uploaded
        [project]="project"
        [versions]="versions"
        [feedbacks]="feedbacks"
      ></project-details-versions-uploaded>
    </div> 
    <core-helpers-box-alert-message-icon *ngIf="status == DONE && versions.length == 0"
        [text]="'You don’t have permission to see these artworks.'"
        [icon]="'alert'"
    ></core-helpers-box-alert-message-icon>
  <div class="uploaded-tip" [hidden]="status == DONE && versions.length == 0 ">
    <p><em></em><span> Artworks uploaded from this project</span></p>
  </div>
</div>